/**
 * @file The purchase album view.
 */

import React from 'react';

import PurchaseAlbumContainer from '../../containers/purchase/PurchaseAlbumContainer';

const PurchaseAlbumView = () => <PurchaseAlbumContainer />;

export default PurchaseAlbumView;
